import FirstStartAnimation from './FirstStartAnimation';
import React from 'react';
import CloseAllAnimation from './CloseAllAnimation';

function AnimationProvider() {
    return <>
        <FirstStartAnimation/>
        <CloseAllAnimation/>
    </>;
}

export default AnimationProvider;
